export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5173'
export const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || 'http://localhost:3001'

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'callizy_auth_token',
  REFRESH_TOKEN: 'callizy_refresh_token',
  USER_ID: 'callizy_user_id',
  USER_EMAIL: 'callizy_user_email',
  USER_FIRST_NAME: 'callizy_user_first_name',
  USER_LAST_NAME: 'callizy_user_last_name',
  USER_ROLE: 'callizy_user_role',
  COMPANY_ID: 'callizy_company_id',
  COMPANY_NAME: 'callizy_company_name',
  ACCOUNT_DELETED: 'callizy_account_deleted',
  PASSKEY_NUDGE_DISMISSED_AT: 'callizy_passkey_nudge_dismissed_at',
  MAC_UPDATE_DISMISSED_AT: 'callizy_mac_update_dismissed_at',
} as const

/** Première version de l'app Mac qui supporte les passkeys (entitlement
 *  webcredentials + flag JS injectée). Les versions antérieures voient un
 *  toast d'invitation à mettre à jour. */
export const MIN_MAC_VERSION_FOR_PASSKEYS = '1.1.0'

/** URL canonique du .dmg distribué via S3+CloudFront. */
export const MAC_DMG_URL = 'https://app.callizy.ca/downloads/Callizy.dmg'

export const CONFIG = {
  API_BASE_URL,
  FRONTEND_URL,
  MARKETING_URL,
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const
